// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"3f296907","707":"381f8b96","729":"680f1706"}[chunkId] + ".js";
};